/**
 * Lightweight pub/sub singleton used to track whether the app is currently
 * able to reach the backend server. When a request fails to connect (after
 * retries), `setServerDown(true)` is called from ServerOperations, and any
 * subscribers (e.g. App.js) can react by showing a maintenance screen.
 */

let serverDown = false;
let listeners = [];

export const isServerDown = () => serverDown;

export const setServerDown = (value) => {
    if (serverDown === value) return;
    serverDown = value;
    listeners.forEach((listener) => {
        try {
            listener(serverDown);
        } catch (error) {
            console.error('ConnectionManager listener error:', error);
        }
    });
};

/**
 * Subscribe to server connectivity changes.
 * Returns an unsubscribe function.
 */
export const subscribe = (listener) => {
    listeners.push(listener);
    return () => {
        listeners = listeners.filter((l) => l !== listener);
    };
};
